import Point = google.maps.Point;
import {Constants} from '../../constants';
import { environment } from '../../../environments/environment';

export class TilingUtils {

    static readonly subdomains = ['a', 'b', 'c', 'd'];

    /**
     * This will append a subdomain in front of the main domain. This subdomain is generated randomly based on zoom and tile index
     */
    static getUrlWithSubdomainForTile(point: Point, zoom: number): string {
        const hosts = environment.tileHosts && environment.tileHosts.length ? environment.tileHosts : null;
        if (hosts) {
            const idx = Math.abs(point.x + point.y + zoom) % hosts.length;
            return hosts[idx];
        }
        let baseDomain = Constants.BASE_DOMAIN;
        let subdomain = TilingUtils.subdomains[(point.x + point.y + zoom) % 4];
        return baseDomain.replace('://', `://${subdomain}.`);
    }
}
